const m08Section = {
  id: 'm08',
  name: '2027ScoresheetM08Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM08Sub2Label',
      id: 'm08_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
  ]
}

export default m08Section;